













































































































































































































































































































































































































































































































































































































































import dayjs from 'dayjs'
import { Component, Vue, Watch } from 'vue-property-decorator'
import { Validations } from 'vuelidate-property-decorators'
import { validationMixin } from 'vuelidate'
import {
  required,
  maxLength,
  requiredIf,
  minLength,
  and,
  minValue,
} from 'vuelidate/lib/validators'
import controller from '@/app/ui/controllers/ProgrammaticVoucherController'
import routeController, { Data } from '@/app/ui/controllers/RouteController'
import Button from '@/app/ui/components/Button/index.vue'
import Modal from '@/app/ui/components/Modal/index.vue'
import LoadingOverlay from '@/app/ui/components/LoadingOverlay/index.vue'
import OptionBox from '@/app/ui/components/OptionBox/index.vue'
import VoucherTextInput from '../../components/VoucherTextInput/index.vue'
import VoucherDropdown from '../../components/VoucherDropdown/index.vue'
import VoucherDatePicker from '../../components/VoucherDatePicker/index.vue'
import { EventBus, EventBusConstants } from '@/app/infrastructures/misc'
import { semanticVersioning } from '@/app/infrastructures/misc/ValidationRules'
import Toggle from '@/app/ui/components/Toggle/index.vue'

@Component({
  mixins: [validationMixin],
  components: {
    Button,
    Modal,
    VoucherTextInput,
    VoucherDropdown,
    VoucherDatePicker,
    OptionBox,
    LoadingOverlay,
    Toggle,
  },
})
export default class CreateProgrammaticVoucher extends Vue {
  controller = controller
  routeController = routeController
  maxCount = 30
  form = {
    voucherName: '',
    voucherTarget: [] as Record<string, any>,
    selectedUserFile: new File([], ''),
    os: [] as Record<string, any>,
    osValidation: [] as Record<string, any>,
    osValidationVersion: '',
    routeIds: [] as Record<string, any>[],
    membershipLevel: [] as Record<string, any>,
    voucherTrigger: [] as Record<string, any>,
    scheduleDate: '',
    scheduleTime: '',
    membershipLevelUp: [] as Record<string, any>,
    limitPerDay: 1,
    triggerInvoiceType: [] as string[],
    voucherPurposeParent: [] as Record<string, any>,
    voucherPurposeChild: [] as Record<string, any>,
    pointAmount: 0,
    pointExpiry: 1,
    pointPurpose: [] as string[],
    discountAmount: 0,
    discountMinimum: 0,
    discountPercentage: 0,
    discountPercentageMinimum: 0,
    discountPercentageMaximum: 0,
    cashbackPercentage: 0,
    cashbackPercentageMinimum: 0,
    cashbackPercentageMaximum: 0,
    voucherPurposeInvoiceType: [] as string[],
    expiryDay: 1,
    limitUsage: 1,
    startDate: '',
    startTime: '',
    endDate: '',
    endTime: '',
    budgetAmount: <null | number | undefined>null,
  }
  toggleBudgetAmount = false
  successModal = false
  confirmationModal = false
  todayDate = dayjs().format('YYYY-MM-DD')
  hasChanged = {
    voucherName: false,
    voucherTarget: false,
    selectedUserFile: false,
    os: false,
    osValidation: false,
    osValidationVersion: false,
    routeIds: false,
    membershipLevel: false,
    voucherTrigger: false,
    scheduleDate: false,
    scheduleTime: false,
    membershipLevelUp: false,
    limitPerDay: false,
    triggerInvoiceType: false,
    voucherPurposeParent: false,
    voucherPurposeChild: false,
    pointAmount: false,
    pointExpiry: false,
    pointPurpose: false,
    discountAmount: false,
    discountMinimum: false,
    discountPercentage: false,
    discountPercentageMinimum: false,
    discountPercentageMaximum: false,
    cashbackPercentage: false,
    cashbackPercentageMinimum: false,
    cashbackPercentageMaximum: false,
    voucherPurposeInvoiceType: false,
    expiryDay: false,
    limitUsage: false,
    startDate: false,
    startTime: false,
    endDate: false,
    endTime: false,
    budgetAmount: false,
  }

  created(): void {
    controller.getTriggers()

    EventBus.$on(EventBusConstants.CREATE_VOUCHER_SUCCESS, () => {
      this.successModal = true
    })
  }

  @Validations()
  validations() {
    const validate = {
      form: {
        voucherName: {
          required,
          minLength: minLength(3),
          maxLength: maxLength(30),
        },
        voucherTarget: { required },
        selectedUserFile: {
          name: {
            requiredIf: requiredIf(
              () =>
                this.form.voucherTarget ===
                this.controller.constants.targetOptions[1]
            ),
          },
        },
        os: {
          requiredIf: requiredIf(
            () =>
              this.form.voucherTarget ===
              this.controller.constants.targetOptions[2]
          ),
        },
        osValidation: {
          requiredIf: requiredIf(
            () =>
              this.form.voucherTarget ===
              this.controller.constants.targetOptions[2]
          ),
        },
        osValidationVersion: {
          requiredIf: and(
            requiredIf(
              () =>
                this.form.voucherTarget ===
                this.controller.constants.targetOptions[2]
            ),
            semanticVersioning
          ),
        },
        routeIds: {
          requiredIf: requiredIf(
            () =>
              this.form.voucherTarget ===
              this.controller.constants.targetOptions[3]
          ),
        },
        membershipLevel: {
          requiredIf: requiredIf(
            () =>
              this.form.voucherTarget ===
              this.controller.constants.targetOptions[4]
          ),
        },
        voucherTrigger: { required },
        scheduleDate: {
          requiredIf: requiredIf(
            () => this.form.voucherTrigger.value === 'ON_SCHEDULE'
          ),
        },
        scheduleTime: {
          requiredIf: requiredIf(
            () => this.form.voucherTrigger.value === 'ON_SCHEDULE'
          ),
        },
        membershipLevelUp: {
          requiredIf: requiredIf(
            () => this.form.voucherTrigger.value === 'MEMBERSHIP_LEVEL_UP'
          ),
        },
        limitPerDay: {
          requiredIf: requiredIf(
            () => this.form.voucherTrigger.value !== 'ON_SCHEDULE'
          ),
          minValue:
            this.form.voucherTrigger.value !== 'ON_SCHEDULE'
              ? minValue(1)
              : true,
        },
        triggerInvoiceType: {
          requiredIf: and(
            requiredIf(() => this.form.voucherTrigger.value === 'INVOICE_PAID'),
            (value: Array<any>) =>
              this.form.voucherTrigger.value === 'INVOICE_PAID'
                ? value.length > 0
                : true
          ),
        },
        voucherPurposeParent: { required },
        voucherPurposeChild: { required },
        pointAmount: {
          requiredIf: requiredIf(
            () =>
              this.form.voucherPurposeChild ===
              this.controller.constants.tncOptions[0]
          ),
        },
        pointExpiry: {
          requiredIf: requiredIf(
            () =>
              this.form.voucherPurposeChild ===
                this.controller.constants.tncOptions[0] ||
              this.form.voucherPurposeChild ===
                this.controller.constants.tncOptions[3]
          ),
          minValue:
            this.form.voucherPurposeChild ===
              this.controller.constants.tncOptions[0] ||
            this.form.voucherPurposeChild ===
              this.controller.constants.tncOptions[3]
              ? minValue(1)
              : true,
        },
        pointPurpose: {
          requiredIf: and(
            requiredIf(
              () =>
                this.form.voucherPurposeChild ===
                  this.controller.constants.tncOptions[0] ||
                this.form.voucherPurposeChild ===
                  this.controller.constants.tncOptions[3]
            ),
            (value: Array<any>) =>
              this.form.voucherPurposeChild ===
                this.controller.constants.tncOptions[0] ||
              this.form.voucherPurposeChild ===
                this.controller.constants.tncOptions[3]
                ? value.length > 0
                : true
          ),
        },
        discountAmount: {
          requiredIf: requiredIf(
            () =>
              this.form.voucherPurposeChild ===
              this.controller.constants.tncOptions[1]
          ),
        },
        discountMinimum: {
          requiredIf: requiredIf(
            () =>
              this.form.voucherPurposeChild ===
              this.controller.constants.tncOptions[1]
          ),
        },
        discountPercentage: {
          requiredIf: requiredIf(
            () =>
              this.form.voucherPurposeChild ===
              this.controller.constants.tncOptions[2]
          ),
        },
        discountPercentageMinimum: {
          requiredIf: requiredIf(
            () =>
              this.form.voucherPurposeChild ===
              this.controller.constants.tncOptions[2]
          ),
        },
        discountPercentageMaximum: {
          requiredIf: requiredIf(
            () =>
              this.form.voucherPurposeChild ===
              this.controller.constants.tncOptions[2]
          ),
        },
        cashbackPercentage: {
          requiredIf: requiredIf(
            () =>
              this.form.voucherPurposeChild ===
              this.controller.constants.tncOptions[3]
          ),
        },
        cashbackPercentageMinimum: {
          requiredIf: requiredIf(
            () =>
              this.form.voucherPurposeChild ===
              this.controller.constants.tncOptions[3]
          ),
        },
        cashbackPercentageMaximum: {
          requiredIf: requiredIf(
            () =>
              this.form.voucherPurposeChild ===
              this.controller.constants.tncOptions[3]
          ),
        },
        voucherPurposeInvoiceType: {
          requiredIf: and(
            requiredIf(
              () =>
                this.form.voucherPurposeChild !==
                this.controller.constants.tncOptions[0]
            ),
            (value: Array<any>) =>
              this.form.voucherPurposeChild !==
              this.controller.constants.tncOptions[0]
                ? value.length > 0
                : true
          ),
        },
        expiryDay: { required, minValue: minValue(1) },
        limitUsage: {
          requiredIf: requiredIf(
            () =>
              this.form.voucherPurposeChild !==
              this.controller.constants.tncOptions[0]
          ),
          minValue:
            this.form.voucherPurposeChild !==
            this.controller.constants.tncOptions[0]
              ? minValue(1)
              : true,
        },
        startDate: {
          requiredIf: requiredIf(
            () => this.form.voucherTrigger.value !== 'ON_SCHEDULE'
          ),
        },
        startTime: {
          requiredIf: requiredIf(
            () => this.form.voucherTrigger.value !== 'ON_SCHEDULE'
          ),
        },
        endDate: {
          requiredIf: requiredIf(
            () => this.form.voucherTrigger.value !== 'ON_SCHEDULE'
          ),
        },
        endTime: {
          requiredIf: requiredIf(
            () => this.form.voucherTrigger.value !== 'ON_SCHEDULE'
          ),
        },
        budgetAmount: {
          requiredIf: requiredIf(
            () => this.toggleBudgetAmount
          ),
          minValue:
            this.toggleBudgetAmount
            ? minValue(this.validateBudgetAmount) : true
        }
      },
    }

    return validate
  }

  get validateBudgetAmount(): number {
    if (this.isDiscByAmount) {
      return this.form.discountAmount
    } else if (this.isDiscByPercent) {
      return this.form.discountPercentageMaximum
    } else if (this.isCashback) {
      return this.form.cashbackPercentageMaximum
    } else if (this.isRedeemToPoint) {
      return this.form.pointAmount
    }
    return 1
  }

  get errorMessageBudgetAmount(): string | undefined {
    if (!this.$v.form.budgetAmount?.requiredIf && this.hasChanged.budgetAmount) {
      return 'Budget amount can’t be 0'
    } else if (!this.$v.form.budgetAmount?.minValue && this.hasChanged.budgetAmount) {
      return 'Budget amount must be higher than the point/discount amount'
    }
    return undefined
  }

  @Watch('form.voucherTarget')
  onTargetUserChanged(val: Record<string, any>): void {
    if (val === controller.constants.targetOptions[3]) {
      routeController.getCityList()
    }
  }

  @Watch('form.voucherPurposeParent')
  onVoucherPurposeParentChanged(): void {
    this.form.voucherPurposeChild = [] as Record<string, any>
    this.form.pointAmount = 0
    this.form.pointExpiry = 0
    this.form.pointPurpose = [] as string[]
    this.form.discountAmount = 0
    this.form.discountMinimum = 0
    this.form.discountPercentage = 0
    this.form.discountPercentageMinimum = 0
    this.form.discountPercentageMaximum = 0
    this.form.cashbackPercentage = 0
    this.form.cashbackPercentageMinimum = 0
    this.form.cashbackPercentageMaximum = 0
    this.form.voucherPurposeInvoiceType = [] as string[]
    this.form.expiryDay = 0
    this.form.limitUsage = 1
    this.form.startDate = ''
    this.form.startTime = ''
    this.form.endDate = ''
    this.form.endTime = ''
  }

  @Watch('form.voucherTrigger')
  onChange(): void {
    if (!(this.form.voucherTrigger instanceof Array) && this.isOnSchedule) {
      this.toggleBudgetAmount = false
      this.form.budgetAmount = 0
    }
  }

  get isOnSchedule(): boolean {
    return this.form.voucherTrigger.value === 'ON_SCHEDULE'
  }

  get isRedeemToPoint(): boolean {
    return this.form.voucherPurposeChild === controller.constants.tncOptions[0]
  }

  get isDiscByAmount(): boolean {
    return this.form.voucherPurposeChild === controller.constants.tncOptions[1]
  }

  get isDiscByPercent(): boolean {
    return this.form.voucherPurposeChild === controller.constants.tncOptions[2]
  }

  get isCashback(): boolean {
    return this.form.voucherPurposeChild === controller.constants.tncOptions[3]
  }

  get triggerOptions() {
    return controller.triggerData
  }

  get routeOptions(): Data[] {
    return routeController.cityData
  }

  get childPurposeOptions() {
    return this.form.voucherPurposeParent.value === 'REDEEM_TO_POINT'
      ? controller.constants.tncOptions.filter(
          (item) => item.value === 'REDEEM_TO_POINT'
        )
      : controller.constants.tncOptions.filter(
          (item) => item.value !== 'REDEEM_TO_POINT'
        )
  }

  get voucherPointPurposeOptions() {
    return controller.constants.pointPurposes
  }

  get fileAttachmentName(): string | null {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return this.form.selectedUserFile ? this.form.selectedUserFile.name! : null
  }

  private setAllChanged() {
    this.hasChanged = {
      voucherName: true,
      voucherTarget: true,
      selectedUserFile: true,
      os: true,
      osValidation: true,
      osValidationVersion: true,
      routeIds: true,
      membershipLevel: true,
      voucherTrigger: true,
      scheduleDate: true,
      scheduleTime: true,
      membershipLevelUp: true,
      limitPerDay: true,
      triggerInvoiceType: true,
      voucherPurposeParent: true,
      voucherPurposeChild: true,
      pointAmount: true,
      pointExpiry: true,
      pointPurpose: true,
      discountAmount: true,
      discountMinimum: true,
      discountPercentage: true,
      discountPercentageMinimum: true,
      discountPercentageMaximum: true,
      cashbackPercentage: true,
      cashbackPercentageMinimum: true,
      cashbackPercentageMaximum: true,
      voucherPurposeInvoiceType: true,
      expiryDay: true,
      limitUsage: true,
      startDate: true,
      startTime: true,
      endDate: true,
      endTime: true,
      budgetAmount: true,
    }
  }

  private setTriggerInvoiceType(value: string) {
    this.hasChanged.triggerInvoiceType = true
    if (this.form.triggerInvoiceType.includes(value)) {
      this.form.triggerInvoiceType = this.form.triggerInvoiceType.filter(
        (item) => item !== value
      )
    } else {
      this.form.triggerInvoiceType.push(value)
    }
  }

  private setShipmentType(value: string) {
    this.hasChanged.voucherPurposeInvoiceType = true
    if (this.form.voucherPurposeInvoiceType.includes(value)) {
      this.form.voucherPurposeInvoiceType = this.form.voucherPurposeInvoiceType.filter(
        (item) => item !== value
      )
    } else {
      this.form.voucherPurposeInvoiceType.push(value)
    }
  }

  private setPointPurpose(value: string) {
    this.hasChanged.pointPurpose = true
    if (this.form.pointPurpose.includes(value)) {
      this.form.pointPurpose = this.form.pointPurpose.filter(
        (item) => item !== value
      )
    } else {
      this.form.pointPurpose.push(value)
    }
  }

  private onFileChange($event: File) {
    this.hasChanged.selectedUserFile = true
    this.form.selectedUserFile = $event
  }

  private onCreateVoucher() {
    this.setAllChanged()
    this.confirmationModal = false
    if (!this.$v.form.$invalid) {
      controller.createProgrammaticVoucher(this.form)
    } else {
      Vue.notify({
        title: 'Invalid Form Program Voucher',
        text: 'Please check every invalid form',
        type: 'error',
        duration: 5000,
      })
    }
  }

  private onCloseSuccessModal() {
    this.successModal = false
    this.$router.push({ name: 'ProgrammaticVoucherPage' })
  }

  private isToggleBudgetAmount() {
    this.toggleBudgetAmount = !this.toggleBudgetAmount
    this.form.budgetAmount = 0
  }

  beforeDestroy(): void {
    EventBus.$off(EventBusConstants.CREATE_VOUCHER_SUCCESS)
  }
}
